<template>
	<div class="spinner-wrapper"><div class="spinner"></div></div>
</template>

<script>
export default {
	name: "PlainSpinner"
}
</script>

<style scoped>

</style>